import { FormlyFieldConfig } from '@ngx-formly/core';

export function addonsExtension(field: FormlyFieldConfig) {
  if (!field.props || (field.wrappers && field.wrappers.indexOf('addons') !== -1)) {
    return;
  }

  if (
    field.props.addonLeft?.text ||
    field.props.addonLeft?.icon ||
    field.props.addonRight?.text ||
    field.props.addonRight?.icon
  ) {
    field.wrappers = [...(field.wrappers || []), 'addons'];
  }
}
